export default __webpack_public_path__ + "static/media/link-clicks-campaign-img.b1a2a3f7.png";